<!--
    描述：工种基本信息tab页列表页面
    时间：2020-06-16
    Created by yefan
-->
<template>
	<div class="w-page-main">
		<div class="w-page-header">
			<div class="w-page-header">
				<search-area ref="searchContent"
							 :showMore="false"
							 v-model="searchForm.sname"
							 placeholderName="请输入工种"
							 @on-search="getLaborTable(searchForm.sname)"
							 @on-refresh="onRefresh"></search-area>
				<div class="btnGroups ml10">
					<el-button type="primary"
							   size="small"
							   @click="addLabor">添加工种</el-button>
				</div>
			</div>
		</div>
		<div class="w-page-container">
			<div class="w-table-layout w-table-page">
				<transition name="fade"
							mode="out-in">
					<!-- 列表 -->
					<div class="list-wrap w-table-content"
						 ref="tableContent"
						 key="list">
						<el-table :data="tableObj.tableData"
								  row-key="id"
								  v-loading="tableObj.loading"
								  ref="tableObj"
								  default-expand-all
								  :height="tableObj.tableH"
								  border
								  highlight-current-row>
							<el-table-column type="index"
											 lable="序号"
											 align="center"
											 width="100"></el-table-column>
							<el-table-column prop="code"
											 label="编号"
											 align="center"
											 show-overflow-tooltip
											 min-width="120"></el-table-column>
							<el-table-column prop="sname"
											 label="工种"
											 align="center"
											 show-overflow-tooltip
											 min-width="180"></el-table-column>
							<el-table-column label="操作"
											 align="center"
											 show-overflow-tooltip
											 width="120">
								<template slot-scope="scope">
									<el-button size="mini"
											   icon="el-icon-edit"
											   title="编辑"
											   type="text"
											   @click="doEdit(scope.row)"></el-button>
									<el-button size="mini"
											   icon="el-icon-delete"
											   title="删除"
											   type="text"
											   @click="doDelete(scope.row.id)"></el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</transition>

				<!-- 底部分页 -->
				<div class="w-table-footer">
					<el-pagination @size-change="handleSizeChange"
								   @current-change="handleCurrentChange"
								   :current-page="tableObj.currentPage"
								   :page-sizes="tableObj.pageList"
								   :page-size="tableObj.pageSize"
								   layout="total, sizes, prev, pager, next, jumper"
								   :total="tableObj.total">
					</el-pagination>
				</div>
			</div>
		</div>

		<!-- 添加工种弹窗 -->
		<el-dialog title="添加工种"
				   :visible.sync="addVisible"
				   width="30%">
			<el-form :model="addData"
					 ref="addData"
					 :rules="formRules"
					 label-width="100px">
				<el-row>
					<el-col>
						<el-form-item label="工种"
									  prop="sname">
							<el-input placeholder="请输入"
									  v-model="addData.sname"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col>
						<el-form-item label="编码"
									  prop="code">
							<el-input placeholder="请输入"
									  v-model="addData.code"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col>
						<el-form-item label="备注"
									  prop="tag">
							<el-input placeholder="请输入"
									  v-model="addData.tag"></el-input>
						</el-form-item>
					</el-col>
				</el-row>

			</el-form>
			<span slot="footer"
				  class="dialog-footer">
				<el-button @click="addVisible = false">取 消</el-button>
				<el-button type="primary"
						   @click="saveLabor">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 编辑工种弹窗 -->
		<el-dialog title="编辑工种"
				   :visible.sync="editVisible"
				   width="30%">
			<el-form :model="editData"
					 ref="editData"
					 :rules="formRules"
					 label-width="100px">
				<el-row>
					<el-col>
						<el-form-item label="工种"
									  prop="sname">
							<el-input placeholder="请输入"
									  v-model="editData.sname"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col>
						<el-form-item label="编码"
									  prop="code">
							<el-input placeholder="请输入"
									  v-model="editData.code"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col>
						<el-form-item label="备注"
									  prop="tag">
							<el-input placeholder="请输入"
									  v-model="editData.tag"></el-input>
						</el-form-item>
					</el-col>
				</el-row>

			</el-form>
			<span slot="footer"
				  class="dialog-footer">
				<el-button @click="editVisible = false">取 消</el-button>
				<el-button type="primary"
						   @click="confirmUpdate">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { getAnalysisTemplates } from '@/api/modules/analysis.js'
import {
	getLabor,
	addL,
	updateLabor,
	delLabor
} from '@/api/modules/resource.js'

export default {
	data() {
		return {
			searchForm: {
				sname: ''
			},
			tableObj: {
				loading: false,
				tableH: 400,
				tableData: [],
				currentPage: 1, // 当前页码
				pageList: [10, 20, 50, 100], // 显示条数数组
				pageSize: 10, // 当前显示条数
				total: 0 // 当前总条数
			},
			addVisible: false,
			addData: {},
			editVisible: false,
			editData: {},
			formRules: {
				// 表单验证
				sname: [
					{
						required: true,
						message: '请输入材料名称',
						trigger: 'blur'
					},
					{
						min: 0,
						max: 80,
						message: '最多80个字符',
						trigger: 'blur'
					}
				],
				type: [
					{
						required: true,
						message: '请选择材料分类',
						trigger: 'blur'
					}
				],
				code: [
					{
						required: true,
						message: '请输入材料编码',
						trigger: 'blur'
					},
					{
						min: 0,
						max: 80,
						message: '最多80个字符',
						trigger: 'blur'
					}
				],
				specification: [
					{
						required: true,
						message: '请输入规格型号',
						trigger: 'blur'
					},
					{
						min: 0,
						max: 80,
						message: '最多80个字符',
						trigger: 'blur'
					}
				],
				unit: [
					{
						required: true,
						message: '请选择单位',
						trigger: 'change'
					}
				]
			}
		}
	},
	created() {
		this.getLaborTable()
	},
	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.tableObj.tableH = this.$refs.tableContent.offsetHeight
			}, 100)
		})
	},
	// 进入缓存页面触发
	activated() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.tableObj.tableH = this.$refs.tableContent.offsetHeight
			}, 100)
		})
	},
	methods: {
		//材料列表回显
		getLaborTable(val) {
			//分页参数
			let params = {}
			params.sname = val
			params.current = this.tableObj.currentPage
			params.size = this.tableObj.pageSize
			getLabor(params).then(res => {
				this.tableObj.tableData = res.data.records
				this.tableObj.currentPage = parseInt(res.data.current)
				this.tableObj.total = parseInt(res.data.total)
				this.tableObj.pageSize = parseInt(res.data.size)
			})
		},
		//编辑按钮事件
		doEdit(val) {
			this.editVisible = true
			this.editData = val
		},
		//确认编辑
		confirmUpdate() {
			let params = Object.assign({}, this.editData)
			this.$refs.editData.validate(valid => {
				if (valid) {
					updateLabor(this.editData).then(res => {
						if (res.operationCode == 1) {
							this.$message.success('修改成功')
							this.editVisible = false
							this.getLaborTable()
						} else {
							this.$message.warning('已存在相同编码')
						}
					})
				}
			})
		},
		//删除事件
		doDelete(val) {
			this.$confirm('确认要删除当前数据吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				delLabor({ id: val }).then(res => {
					this.$message.success('删除成功')
					this.getLaborTable()
				})
			})
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.tableObj.pageSize = val
			this.getLaborTable()
		},

		// 切换当前页码
		handleCurrentChange(cur) {
			this.tableObj.currentPage = cur
			this.getLaborTable()
		},

		// 确认搜索
		onSearch() {
			this.getTablePageList()
		},

		// 点击刷新
		onRefresh() {
			this.searchForm.sname = ''
			this.getLaborTable()
		},

		// // 点击重置
		// onReset() {
		// 	this.searchForm.sname = ''
		// },

		// 点击新增材料
		addLabor() {
			this.addVisible = true
		},

		//新增工种
		saveLabor() {
			let params = Object.assign({}, this.addData)
			this.$refs.addData.validate(valid => {
				if (valid) {
					addL(params).then(res => {
						if (res.operationCode == 1) {
							this.$message.success('添加成功')
							;(this.addVisible = false), (this.addData = {})
							this.getLaborTable()
						} else {
							this.$message.warning('已存在相同编码')
						}
					})
				}
			})
		}
	},

	computed: {
		...mapState('app', { clientSize: state => state.clientSize }),
		...mapState('menu', {
			roleBtns: state => state.roleBtns
		})
	},

	watch: {
		clientSize(val) {
			this.tableObj.tableH = this.$refs.tableContent.offsetHeight
		}
	}
}
</script>

<style scoped>
</style>